import { InputComponent } from "components/components/Component";
import { DateInputBaseDefinition, DateInputBaseComponent } from "components/input/baseInputDefinition";
import { DateRangeData, DateRangeString } from "components/input/baseHTMLElementDateInput";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import template from "./dateRange.hbs";
import "./dateRange.scss";
import { DateRangeInputElement, initDateRangeInputWebComponent } from "./dateRangeElement";

initDateRangeInputWebComponent();

export class DateRangeInput extends DateInputBaseComponent<DateRangeInputDefinition> implements InputComponent {

    public readonly componentType: string = "dateRangeInput";

    private element: DateRangeInputElement;

    constructor(schema: DateRangeInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-date-range-input");

        this.genericBindEvents(this.element, false);
    }

    public getValue(): DateRangeData {
        return this.element.data;
    }

    public value(v: DateRangeString | DateRangeData) {
        if (v != null) {
            let from = (v.from != null) ? new Date(v.from) : null;
            let to = (v.to != null) ? new Date(v.to) : null;
            this.element.data = {
                from,
                to,
            };
        } else {
            this.element.data = null;
        }
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface DateRangeInputDefinition extends DateInputBaseDefinition {
}
